import moment, { Moment } from 'moment';
import 'moment/locale/es';

export const getReportPeriodLabel = (period: {
	openTime: string | Moment;
	closeTime: string | Moment;
	scheduledType?: string;
}) => {
	const open = moment(period.openTime);
	const close = moment(period.closeTime);
	const scheduledType = period.scheduledType;

	const range = (
		<>
			{open.format('D MMM YYYY')}
			<span style={{ fontWeight: 'normal', color: '#a4b2c4', margin: '0 6px' }}>→</span>
			{close.format('D MMM YYYY')}
		</>
	);

	const detail =
		scheduledType === 'monthly'
			? `Mensual · ${open.format('MMMM YYYY')}`
			: scheduledType === 'weekly'
				? `Informe semanal · De ${open.format('dddd')} a ${close.format('dddd')}`
				: null;

	const previousLabel =
		scheduledType === 'monthly'
			? 'Mes anterior'
			: scheduledType === 'weekly'
				? 'Semana anterior'
				: null;

	return { range, detail, previousLabel };
};

export const ReportPeriodDisplay = (props: {
	openTime: string | Moment;
	closeTime: string | Moment;
	scheduledType?: string;
	compact?: boolean;
	rangeOnly?: boolean;
}) => {
	const { range, detail, previousLabel } = getReportPeriodLabel(props);

	return (
		<div style={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			lineHeight: props.compact ? 1.15 : 1.2,
			gap: 0,
			marginTop: props.compact ? 4 : 0,
		}}>
			<span style={{
				fontWeight: 500,
				color: props.compact ? '#64748b' : '#222950',
				fontSize: props.compact ? 10 : undefined,
			}}>
				{range}
			</span>
			{previousLabel && (
				<span style={{
					fontSize: props.compact ? 10 : 11,
					fontWeight: 500,
					color: '#94a3b8',
					marginTop: 4,
				}}>
					{previousLabel}
				</span>
			)}
			{!props.rangeOnly && detail && (
				<span style={{ fontSize: props.compact ? 10 : 11, color: '#82a3b5' }}>
					{detail}
				</span>
			)}
		</div>
	);
};
